const PHONE_LIKE_ACCOUNT_REGEX = /^1\d{10}$/

/**
 * @description 将手机号样式的账号值归一化为 11 位手机号样式账号。
 * @reason IMS 返回的 account_name 可能包含 +86、0086、空格或连字符，直接用于展示/浏览器密码管理会导致回填格式错误。
 * @reason 这里故意不用真实运营商号段校验，避免测试账号如 1222... 因为不是 13-19 号段而保留 +86。
 * @param {string | number | null | undefined} value - 原始手机号或账号值
 * @returns {string} 归一化后的手机号样式账号；如果不是可识别的 11 位手机号样式，则返回原始去首尾空格后的值
 */
export const normalizeChinaMobile = (value) => {
  const raw = value === null || value === undefined ? '' : String(value).trim()
  if (!raw) return ''

  const compactValue = raw.replace(/[\s-]/g, '')
  const withoutCountryCode = compactValue.replace(/^(?:\+?86|0086)/, '')
  const digitsOnly = withoutCountryCode.replace(/[^\d]/g, '')

  if (PHONE_LIKE_ACCOUNT_REGEX.test(digitsOnly)) {
    return digitsOnly
  }

  return raw
}
